import { getDB } from './index';

/**
 * Generic key-value store for sync bookkeeping (lastSyncAt per baby,
 * last-error timestamps, etc.). Keep it boring — opaque blobs by string key.
 */

export async function getMeta(key) {
  const row = await getDB().meta.get(key);
  return row ? row.value : null;
}

export async function setMeta(key, value) {
  await getDB().meta.put({ key, value });
}

export async function deleteMeta(key) {
  await getDB().meta.delete(key);
}

export const META_KEYS = {
  lastSyncAt: (babyId) => `lastSyncAt:${babyId}`,
  lastFullPullAt: (babyId) => `lastFullPullAt:${babyId}`,
};
